import { api } from '../../lib/api';

export const MENU_CLASS_META = {
  Star: { label: 'Star', tone: 'success', hint: 'High popularity · high profit' },
  Plowhorse: { label: 'Plowhorse', tone: 'warning', hint: 'High popularity · low profit' },
  Puzzle: { label: 'Puzzle', tone: 'info', hint: 'Low popularity · high profit' },
  Dog: { label: 'Dog', tone: 'danger', hint: 'Low popularity · low profit' },
};

export const menuClassMeta = (c) =>
  MENU_CLASS_META[c] || { label: c, tone: 'neutral', hint: '' };

export const menuApi = {
  list: () => api.get('/menu-analyses'),
  get: (id) => api.get(`/menu-analyses/${id}`),
  create: (payload) => api.post('/menu-analyses', payload),
  update: (id, payload) => api.put(`/menu-analyses/${id}`, payload),
  remove: (id) => api.del(`/menu-analyses/${id}`),
  preview: (lines) => api.post('/menu-analyses/preview', { lines }),
};
